export const env = {
  SECRET_KEY:
    "71e1518c1cc9c5ffca9f68bb813b8fbf9d90008be91da2fc2f830d42b61633d887ec05cadbdbc9ec9ee168cf4b7b3846c7619f027db5c5b1339e2105826ba465",
  // BASE_URL: "http://localhost:3333",
  BASE_URL: "https://adminapi.sstpro.org",
  // BASE_URL: "https://sast2.vercel.app", // vercel URL
};
